/** A widget's own caption line (opening hours, duration): a 14 px icon plus words (the
 *  Icon-And-Words Rule), as the record editor's list widgets caption a row. `error` for what blocks a save (an
 *  input the value cannot hold, a broken rule); `info` for what is only worth knowing
 *  (stored data read leniently) — never red. */
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function WidgetCaption({ tone, children }: { tone: 'error' | 'info'; children: ReactNode }) {
  const Icon = tone === 'error' ? ErrorOutlineIcon : InfoOutlinedIcon;
  return (
    <Typography
      variant="caption"
      component="div"
      color={tone === 'error' ? 'error' : 'text.secondary'}
      data-caption={tone}
      sx={{ display: 'flex', gap: 0.5, alignItems: 'flex-start' }}
    >
      <Icon aria-hidden sx={{ fontSize: 14, mt: '2px', flex: 'none' }} />
      <Box component="span" sx={{ minWidth: 0 }}>
        {children}
      </Box>
    </Typography>
  );
}
